import * as React from 'react';

export const MyCard: React.SFC = () => (
    <div className="MyCard">
        <a href="mailto:capback250@gmail.com?cc=vpodlesnova@dataart.com &amp;subject=Мы пересмотрели условия оффера &amp;body=Мы пересмотрели условия вашего текущего оффера, и хотим повысить ставку :D">
            Sergey Koryakin © 2018
        </a>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/view/MyCard.tsx